import { useQuery } from '@tanstack/react-query';

import { get } from '../../../lib/api';

export const useFetchBroadcastRecipients = ({ id }) => {
  const {
    data: { broadcastRecipients },
  } = useQuery(
    ['broadcastRecipients', id],
    () =>
      get(`/api/client_admin/broadcasts/recipients?broadcast_message_id=${id}`),
    {
      refetchOnWindowFocus: false,
      initialData: {
        broadcastRecipients: [],
      },
    },
  );

  return {
    broadcastRecipients,
  };
};
